import {
  UPDATE_DATA_RETENTION_SETTINGS,
  UPDATE_DATA_RETENTION_SETTINGS_SUCCESS,
  UPDATE_DATA_RETENTION_SETTINGS_ERROR,
} from './actionTypes';

export const updateDataRetentionSettings = (user, fields) => {
  return {
    type: UPDATE_DATA_RETENTION_SETTINGS,
    payload: { user, fields },
  };
};

export const updateDataRetentionSettingsSuccess = (message) => {
  return {
    type: UPDATE_DATA_RETENTION_SETTINGS_SUCCESS,
    payload: { message },
  };
};

export const updateDataRetentionSettingsError = (msg) => {
  return {
    type: UPDATE_DATA_RETENTION_SETTINGS_ERROR,
    payload: msg,
  };
};
